export default __webpack_public_path__ + "static/media/precision-closed.e3bfbd1a.png";